import { render, staticRenderFns } from "./TdGrid.vue?vue&type=template&id=45e0f8c2&"
import script from "./TdGrid.vue?vue&type=script&lang=js&"
export * from "./TdGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports